import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  CmsBannerComponentMedia,
  CmsResponsiveBannerComponentMedia,
  WindowRef,
} from '@spartacus/core';
import { GenericLinkComponent, GenericLinkComponentService } from '@spartacus/storefront';

declare module '@spartacus/core' {
  interface CMSLinkComponent {
    icon?: CmsBannerComponentMedia | CmsResponsiveBannerComponentMedia;
    name?: string;
  }
}

@Component({
  selector: 'cx-generic-link',
  templateUrl: './custom-generic-link.component.html',
  styleUrls: ['./custom-generic-link.component.scss'],
  standalone: false
})
export class CustomGenericLinkComponent extends GenericLinkComponent implements OnInit {
  @ViewChild('storefront') myDiv: ElementRef;
  @Input() icon: CmsBannerComponentMedia | CmsResponsiveBannerComponentMedia;
  @Input() isMenu = false;
  isPolicyPage = false;

  constructor(
    protected router: Router,
    protected service: GenericLinkComponentService,
    private winRef: WindowRef
  ) {
    super(router, service);
  }

  menuToCategory(isMenu: boolean): void {
    if (isMenu || this.isPolicyPage) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
  }

  ngOnInit(): void {
    const div = this.winRef.document.querySelector('cx-storefront');
    if (div.classList.contains('PolicyPageTemplate')) {
      this.isPolicyPage = true;
    }
    if (this.linkMatchesRouter()) {
      this.class = [this.class, 'current-selected'].join(' ').trim();
    }
  }

  linkMatchesRouter(): boolean {
    return this.router.serializeUrl(this.router.createUrlTree([])) === this.url;
  }
}
